<template>
  <div>
    <div class="coverShow" v-show="viseable">
      <div class="container-gj">
        <div class="container-gd">
          <div class="header-div">
            <div
              style="
                font-size: 18px;
                font-weight: 600;
                color: #2b2f36;
                line-height: 24px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              "
            >
              {{ title }}
            </div>
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
              mode=""
              @click="cancleClick"
              style="width: 13px; height: 13px; position: absolute; right: 20px"
            />
          </div>
          <div class="body-div">{{ message }}</div>
          <div class="btn-div">
            <div class="cancle" @click="cancleClick">取消</div>
            <div class="confirm" @click="confirmClick">确定</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromptPopup",
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "提示",
    },
    message: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      viseable: false,
    };
  },
  methods: {
    cancleClick() {
      this.$emit("cancel");
    },
    confirmClick() {
      this.$emit("confirm");
    },
  },
  watch: {
    showDialog(newVal) {
      console.log("o0t34i-=43it=3it=4-3ti3=4-ti43=-ti34=-ti4=3-", newVal);

      this.viseable = newVal;
    },
  },
};
</script>

<style scoped>
.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  padding: 15px;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 8px;
  z-index: 10000000;
  transform: translate(-50%, -50%);
  padding: 20px;
}

.container-gd {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 380px;
  /* height: 80vh; */
  background: #ffffff;
  border-radius: 8px;
  z-index: 10000000;
  transform: translate(-50%, -50%);
  overflow: hidden;
  /* overflow-y: auto; */
}

.body-div {
  width: 100%;
  padding: 30px 15px;
  box-sizing: border-box;
  font-size: 15px;
  text-align: center;
  color: #191919;
  /* 自动换行 */
  word-wrap: break-word;
}

.btn-div {
  width: 100%;
  height: 46px;
  display: flex;
  justify-content: center;
  /* padding-bottom: 10rpx; */
}

.cancle {
  /* position: absolute; */
  width: 50%;
  height: 46px;
  line-height: 46px;
  left: 0;
  bottom: 0;
  text-align: center;
  border-top: 1px solid #e4e4e4;
  font-size: 17px;
  font-weight: 600;
  color: #3a60ff;
  cursor: pointer;
}

.confirm {
  /* position: absolute; */
  width: 50%;
  height: 46px;
  line-height: 46px;
  right: 0;
  bottom: 0;
  text-align: center;
  border-top: 1px solid #e4e4e4;
  background: #3a60ff;
  font-size: 17px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}

.zz {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  border-bottom: 1px solid #eee;
  padding-left: 10px;
  padding-right: 10px;

  div {
    color: #555555;
    font-size: 15px;
  }
}

/* .zz-picker{
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding-left: 10px;
      padding-right: 10px;
      width: 428rpx;
      height: 88rpx;
      background: #f4f4f4;
      border-radius: 10rpx;
      image{
          width: 40rpx;
          height: 40rpx;
      }
  } */

.no-repeat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
  height: 80px;
}

.no-title {
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  color: #555555;
}

.no-tips {
  font-size: 13px;
  text-align: left;
  color: #7c838e;
}

.center-content {
  width: 92%;
  margin: 10px auto;
  input {
    width: 100%;
    height: 45px;
    background: #f4f4f4;
    border: 2rpx solid #dcdde0;
    border-radius: 4px;
    box-sizing: border-box;
    padding-left: 10px;
  }

  textarea {
    width: 100%;
    height: 500rpx;
    background: #f4f4f4;
    border: 2rpx solid #dcdde0;
    border-radius: 8rpx;
    box-sizing: border-box;
    overflow-y: auto;
  }
}

.header-div {
  width: 100%;
  height: 59px;
  background-color: #ffffff;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 0 14px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
  position: relative;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/PromptPopup/index.vue